<template>
  <section class="app-main">
    <Transition
      name="fade-transform"
      mode="out-in"
    >
      <RouterView />
    </Transition>
  </section>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'AppMain'
})
export default class extends Vue {}
</script>

<style lang="scss" scoped>
.app-main {
  overflow: hidden;
}
</style>
